import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './adalConfig';
import { Investor } from './globalTypes/objects';
import React from 'react';

export const InvestorsContext = React.createContext<Investor[]>([]);

const fetchInvestors = async () => (await apiFetch<Investor[]>('/Api/Investors/GetAll')).data;

function InvestorsProvider({ children }) {
  const { data } = useQuery({
    queryKey: ['investors'],
    queryFn: fetchInvestors,
  });

  return data ? (
    <InvestorsContext.Provider value={data}>{children}</InvestorsContext.Provider>
  ) : null;
}
const InvestorsConsumer = InvestorsContext.Consumer;

export { InvestorsProvider, InvestorsConsumer };
